export enum RouteNameType {
    LoginPage = "LoginPage",
    AddFriendsPage = "AddFriendsPage",
    TextChatPage = "TextChatPage",
    OnlineFriendsPage = "OnlineFriendsPage",
    AllFriendsPage = "AllFriendsPage",
    RelationshipPage = "RelationshipPage",
    ChannelPage = "ChannelPage",
    ChannelRoomPage = "ChannelRoomPage",
    AccountSettingPage = "AccountSettingPage",
    RTCSettingPage = "RTCSettingPage",
    DisplaySettingPage = "DisplaySettingPage",
    GameOverlaySettingPage = "GameOverlaySettingPage",
    HotKeySettingPage = "HotKeySettingPage",
    GameOverlaySettingViewPage = "GameOverlaySettingViewPage",
    GameOverlayPage = "GameOverlayPage",
    ChannelInvitePage = "ChannelInvitePage",
    SoftwareVersionPage = "SoftwareVersionPage",
}

export const routeConfig = {
    [RouteNameType.LoginPage]: { path: "/login" },
    [RouteNameType.AddFriendsPage]: { path: "/friends/add-friends" },
    [RouteNameType.TextChatPage]: { path: "/friends/text-chat/:id/:name" },
    [RouteNameType.OnlineFriendsPage]: { path: "/friends/online-friends" },
    [RouteNameType.AllFriendsPage]: { path: "/friends/all-friends" },
    [RouteNameType.RelationshipPage]: { path: "/friends/relationship" },
    [RouteNameType.ChannelPage]: { path: "/channel" },
    [RouteNameType.ChannelRoomPage]: { path: "/channel/room/:roomUUID" },
    [RouteNameType.AccountSettingPage]: { path: "/setting/account-setting" },
    [RouteNameType.RTCSettingPage]: { path: "/setting/rtc-setting" },
    [RouteNameType.DisplaySettingPage]: { path: "/setting/display-setting" },
    [RouteNameType.GameOverlaySettingPage]: { path: "/setting/game-overlay-setting" },
    [RouteNameType.HotKeySettingPage]: { path: "/setting/hot-key-setting" },
    [RouteNameType.GameOverlaySettingViewPage]: { path: "/screen/game-overlay-setting" },
    [RouteNameType.GameOverlayPage]: { path: "/screen/game-overlay/:roomUUID" },
    [RouteNameType.ChannelInvitePage]: { path: "/channel/invite/:roomKey" },
    [RouteNameType.SoftwareVersionPage]: { path: "/setting/software-version" },
};

export type ChannelRouteName = RouteNameType.ChannelRoomPage | RouteNameType.GameOverlayPage;

export type ExtraRouteConfig = {};

type CheckRouteConfig<
    T extends {
        [name in RouteNameType]: {
            path: string;
        };
    },
> = T;

export type RouteConfig = CheckRouteConfig<typeof routeConfig>;
